<!--
 * @Author: zl
 * @Date: 2022-12-27 08:34:11
 * @LastEditTime: 2023-01-31 11:18:57
 * @LastEditors: zl
 * @Description: 项目相册
-->
<template>
	<div class='project-images'>
		<div class="header-top">
			<div class="left-tabs">
				<el-button type="primary"
						   plain
						   size="small"
						   icon="el-icon-download"
						   @click="topBtnClick('download')">下载</el-button>
			</div>
			<div class="btnGroups">
				<template v-if="activeImageNum > 0">
					<div class="fz14">已选中{{ activeImageNum }}个图片</div>
					<el-button type="primary"
							   size="small"
							   class="mr10 ml10"
							   @click="cancelClick">取消选中</el-button>
				</template>
				<el-input v-model="searchForm.fileName"
						  placeholder="请输入资料名称"
						  size="small"
						  style="width: 360px">
					<el-button type="primary"
							   size="small"
							   class="btn-success"
							   slot="append"
							   @click="getImageData">查询</el-button>
				</el-input>

				<!-- 弹出框搜素区域 -->
				<el-popover placement="bottom-end"
							width="415"
							trigger="click">
					<el-form ref="searchForm"
							 :model="searchForm"
							 size="small"
							 label-width="100px">
						<el-form-item label="主体类型"
									  prop="limitId">
							<el-select v-model="searchForm.limitId"
									   placeholder="请选择"
									   clearable>
								<el-option v-for="item in limitList"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="标段名称"
									  prop="packageId">
							<el-select v-model="searchForm.packageId"
									   placeholder="请选择"
									   clearable>
								<el-option v-for="item in taskList"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="上传单位"
									  prop="shortName">
							<el-input v-model="searchForm.shortName"
									  placeholder="请输入"
									  clearable></el-input>
						</el-form-item>
						<el-form-item label="上传人"
									  prop="userName">
							<el-input v-model="searchForm.userName"
									  placeholder="请输入"
									  clearable></el-input>
						</el-form-item>
						<el-form-item label-width="0"
									  class="text-center borderTop">
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="submitForm">查询</el-button>
							<el-button icon="el-icon-refresh"
									   @click="resetForm">重置</el-button>
						</el-form-item>
					</el-form>
					<el-button type="success"
							   size="small"
							   slot="reference"
							   icon="el-icon-arrow-down"
							   class="ml10 mr10 btn-success"></el-button>
				</el-popover>
			</div>
		</div>
		<div class="container"
			 v-loading="containerLoading">
			<template v-if="this.rightData.length > 0">
				<div class="left pdt10">
					<el-timeline>
						<el-timeline-item v-for="(activity, index) in activities"
										  :key="index + 'activity'"
										  size="large"
										  :class="index == activeIndex ? 'check_color' : ''">
							<span :class="index == activeIndex ? 'active_color' : ''"
								  class="c-p"
								  @click="timeLineClick(index)">{{activity.time}}</span>
							<template slot="dot">
								<div class="circle"
									 :class="index == activeIndex ? 'blue_bgc': ''"
									 @click="timeLineClick(index)">
									<span v-if="index == activeIndex"
										  class="inner-circle"></span>
								</div>
							</template>
						</el-timeline-item>
					</el-timeline>
				</div>
				<div class="right">
					<div ref="box"
						 @scroll="handleScroll($event)"
						 style="height: calc(100vh - 360px);overflow-y:auto;padding-left: 20px;">
						<div v-for="item in rightData"
							 :key="item.time"
							 class="screen">
							<template v-for="i in item.list">
								<div class="screen-box">
									<div class="header mb10">
										<el-checkbox v-model="i.checked"
													 @change="checkBoxChange($event, i)">{{ i.time }}</el-checkbox>
										<el-button size="mini"
												   class="ml10"
												   icon=""
												   @click="i.show = !i.show">
											{{ i.show ? '收起' : '展开' }}
											<i :class="i.show ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
										</el-button>
									</div>
									<div class="content"
										 v-show="i.show">
										<el-popover placement="bottom"
													width="75"
													trigger="hover"
													class="ml10"
													popper-class="images-popover"
													v-for="n in i.list"
													:key="n.id"
													:open-delay="1000">
											<div class="text-center custom-style">
												<el-button type="text"
														   @click="handleClick('preview', n)">预览</el-button>
												<el-button type="text"
														   @click="handleClick('download', n)">下载</el-button>
												<el-button type="text"
														   :disabled="n.createUserid != userInfo.id || n.assortment != 'picture'"
														   @click="handleClick('delete', n)">删除</el-button>
											</div>
											<span slot="reference"
												  class="hoverBox">
												<span class="activeIcon"
													  v-if="n.active">
													<i class="el-icon-check"></i>
												</span>
												<el-image :class="{ activeImg: n.active }"
														  :key="n.id"
														  :src="uploadUrl + n.fileDirectory + n.fileName + '?width=160&height=160'"
														  lazy
														  @click="clickImg(n, i)"
														  @mouseenter="viewInfo(n)">
													<div slot="placeholder"
														 class="image-slot">
														加载中<span class="dot">...</span>
													</div>
													<div slot="error"
														 class="image-slot"
														 @click="clickImg(n, i)">加载失败</div>
												</el-image>
											</span>
										</el-popover>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
				<div class="details"
					 v-loading="detailLoading">
					<template v-if="Object.keys(detailObj).length == 0"></template>
					<template v-else>
						<el-descriptions title="图片详情"
										 :column="1"
										 :colon="false"
										 class="custom-descriptions-images">
							<el-descriptions-item label="资料名称：">
								{{ detailObj.fileName }}
							</el-descriptions-item>
							<el-descriptions-item label="所属资料清单：">
								{{ detailObj.directory }}
							</el-descriptions-item>
							<el-descriptions-item label="关联项目：">
								{{ detailObj.projectName }}
							</el-descriptions-item>
							<el-descriptions-item label="关联标段：">
								{{ detailObj.packName }}
							</el-descriptions-item>
							<el-descriptions-item label="关联任务："
												  v-if="detailObj.task">
								{{ detailObj.task }}
							</el-descriptions-item>
							<el-descriptions-item label="文件编制单位：">
								{{ detailObj.redactUnit }}
							</el-descriptions-item>
							<el-descriptions-item label="上传人：">
								{{ detailObj.userName }}
							</el-descriptions-item>
							<el-descriptions-item label="上传单位：">
								{{ detailObj.shortName }}
							</el-descriptions-item>
							<el-descriptions-item label="上传时间：">
								{{ detailObj.uploadDate }}
							</el-descriptions-item>
							<el-descriptions-item label="创建日期：">
								{{ detailObj.captureDate == null ? '无' : detailObj.captureDate.substr(0, 11) }}
							</el-descriptions-item>
						</el-descriptions>
					</template>
				</div>
			</template>
			<template v-else>
				<el-empty description="暂无数据"
						  class="no-data"></el-empty>
			</template>
		</div>

		<!-- 上传图片 -->
		<el-dialog center
				   :close-on-click-modal="false"
				   title="添加资料"
				   :visible.sync="uploadObj.show"
				   width="1250px"
				   :before-close="uploadClose"
				   :destory-on-close="true">
			<p class="mb10">请将需要上传的文件在此窗口一次性操作完毕，窗口关闭后之前上传的文件将会被覆盖</p>
			<span style="color: red">*</span> 关联任务
			<el-select v-model="uploadObj.taskId"
					   placeholder="请选择"
					   size="small"
					   class="ml10"
					   clearable
					   @change="taskChange">
				<el-option v-for="item in relateData"
						   :key="item.id"
						   :label="item.packName + '（'+ item.auditTypeName +'）'"
						   :value="item.id"></el-option>
			</el-select>
			<myUpload v-if="uploadObj.show"
					  list-type="table"
					  ref="fileUpload"
					  :createUser="userInfo.sname"
					  :createCompany="uploadObj.upUnit"
					  :shortName="uploadObj.shortName"
					  tableName="project_album"
					  assortment="picture"
					  :aid="uploadObj.taskId"
					  :uploadType="2"
					  :acceptType="['PNG','JPG','JPEG']"></myUpload>
			<div slot="footer">
				<el-button class="btn"
						   size="small"
						   @click="uploadClick('cancel')">取 消</el-button>
				<el-button class="btn btn-blue"
						   type="primary"
						   size="small"
						   :loading="uploadObj.loading"
						   @click="uploadClick('submit')">确 定</el-button>
			</div>
		</el-dialog>

		<div class="summary-dlg"
			 :class="{ resetHeight: diaWidth == '500px' }">
			<!-- 单个预览 -->
			<el-dialog title="预览"
					   :visible.sync="previewObj.show"
					   width="50%"
					   center
					   v-dialogDrag
					   :modal="false"
					   :close-on-click-modal="false"
					   :before-close="previewClose"
					   custom-class="summary-dlg">
				<div class="preview-box-projectData">
					<img :src="previewObj.url"
						 alt="">
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import * as API from '@/api/projectMap/projectMapIndex'
import { mapState } from 'vuex'
import { deleteFile } from '@/api/upload/upload'
import { selectTenantInformation } from '@/api/projectManage/ProjectIndex.js'
import VUE_CONFIG from '../../../vue.config.js'
import { previewUrl } from '../../utils/tools'
export default {
	props: {
		projectId: {
			type: String,
			default: '',
		},
		diaWidth: {
			type: String,
			default: '800px',
		},
	},
	components: {},
	data() {
		return {
			searchForm: {
				projectId: '', //项目id
				createTime: '', //创建时间
				limitId: '', //主体id
				userName: '', //创建人
				fileName: '', //文件名
				shortName: '', //创建单位
				packageId: '', //标段id
			},
			activeIndex: 0, //左侧当前激活的
			activities: [], //左侧事件轴
			scrollHeight: [], //右侧所有模块的高度
			rightData: [], //右侧附件轴
			activeImageNum: 0, // 当前选中的图片数
			taskList: [], // 标段合集
			relateData: [], // 关联任务合集
			limitList: [], //主体合集
			detailObj: {}, //照片详情
			uploadObj: {
				show: false,
				taskId: '',
				upUnit: '',
				shortName: '',
				loading: false,
			},
			previewObj: {
				url: '',
				show: false,
			},
			detailLoading: false,
		}
	},
	created() {
		// 获取相册
		this.getImageData()
		// 获取关联任务
		this.getSectionList()
		// 获取当前登录人公司信息
		this.getCompanyMsg()
		// 获取标段
		this.getPackageList()
		// 获取主体
		this.getLimitList()
	},
	mounted() {
		let that = this
		window.onresize = function () {
			setTimeout(() => {
				that.getScrollHeight()
			}, 1000)
		}
	},
	methods: {
		// 左侧点击事件
		timeLineClick(index) {
			let doms = document.getElementsByClassName('container')[0]
			let arr = this.scrollHeight
			// 右侧模块最大高度如果大于父元素的高度说明有滚动条，反之没有
			// 有滚动条就滚动到点击月分位置，没有就只赋值 index
			if (arr[arr.length - 1] > doms.clientHeight) {
				//判断滚动条是否发生了偏远
				this.$refs.box.scrollTo({
					top: arr[index],
					behavior: 'smooth',
				})
			} else {
				this.activeIndex = index
			}
		},

		// 获取右侧每个模块高度
		getScrollHeight() {
			this.scrollHeight = []
			// 获取右侧每一个模板的高度
			if (this.$refs.box) {
				let doms = this.$refs.box.getElementsByClassName('screen')
				let height = 0
				this.scrollHeight.push(height)
				// 把dom对象转换成真正的数组
				let arr = this.$utils.toArray(doms)
				// 将每个模块的高度插入到数组中保存起来
				arr.forEach((x) => {
					height += x.clientHeight
					this.scrollHeight.push(height)
				})
			}
		},

		// 滚动事件
		handleScroll(e) {
			let { target } = e
			let { clientHeight, scrollTop, scrollHeight } = target
			let _index = this.scrollHeight.length
			// 滚动的距离如果大于高度数组中最大的值的话，赋予当前激活index为高度数组的长度减一，即最大值
			if (target.scrollTop > this.scrollHeight[_index - 1]) {
				this.activeIndex = _index - 1
			} else {
				// 循环获取符合滚动距离大于右侧模块高度的数据的下标赋予给当前激活的
				this.scrollHeight.map((item, index) => {
					if (target.scrollTop >= item) {
						this.activeIndex = index
					}
				})
				// 因数据不足时判断滚动条是否到底赋予对应 index
				if (clientHeight + scrollTop == scrollHeight) {
					this.activeIndex = this.activities.length - 1
				}
			}
		},

		/**********   准备工作   **********/

		// 获取相册
		getImageData() {
			let params = this.$utils.clone(this.searchForm, true)
			params.projectId = this.projectId
			this.containerLoading = true
			API.selectProjectPicture(params)
				.then((res) => {
					this.activities = this.$utils.clone(res.data, true)
					this.rightData = this.$utils.clone(res.data, true)
					this.$utils.eachTree(
						this.rightData,
						(item) => {
							if (item.time && item.time.length > 8) {
								this.$set(item, 'show', true)
								this.$set(item, 'checked', false)
							}
						},
						{ children: 'list' }
					)
					this.containerLoading = false
					setTimeout(() => {
						this.getScrollHeight()
					}, 1000)
				})
				.catch(() => {
					this.containerLoading = false
				})
		},

		// 获取当个照片信息
		getImageInfo(data) {
			let params = {
				fileId: data.fileId,
				createUserid: data.createUserid,
				busId: data.busId,
				projectId: data.projectId,
			}
			this.detailLoading = true
			API.selectProjectPictureDetail(params)
				.then((res) => {
					this.detailObj = {}
					this.detailObj = data
					this.detailObj = Object.assign(this.detailObj, res.data)
					this.detailLoading = false
				})
				.catch(() => {
					this.detailLoading = false
				})
		},

		// 获取标段
		getPackageList() {
			API.getSectionInfo({
				projectId: this.projectId,
				tenantId: this.$getSessionItem('tenantId'),
			}).then((res) => {
				this.taskList = res.data
			})
		},

		// 获取关联任务
		getSectionList() {
			API.getUnitList({
				projectId: this.projectId,
				size: 10000,
				current: 1,
			}).then((res) => {
				this.relateData = res.data.records
			})
		},

		// 获取当前登录人公司信息
		getCompanyMsg() {
			selectTenantInformation({
				tenantId: this.$getSessionItem('tenantId'),
			}).then((res) => {
				if (res.data) {
					this.uploadObj.upUnit = res.data.unitName
					this.uploadObj.shortName = res.data.shortName
				}
			})
		},

		// 获取主体
		getLimitList() {
			API.getLimit().then((res) => {
				this.limitList = res.data
			})
		},

		// 删除图片
		deleteFile(data, show) {
			deleteFile({ id: data.id }).then((res) => {
				if (show) {
					this.$message.success('删除成功！')
					this.activeImageNum = 0
					this.getImageData()
					this.previewClose()
				}
			})
		},

		/**
		 * @description: 相片区域点击
		 */

		// 点击预览、下载
		handleClick(type, data) {
			let uploadUrl = ''
			// 本地环境代理后无法直接获取路径
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}

			let url = uploadUrl + data.fileDirectory + data.fileName
			if (type === 'preview') {
				if (parseInt(this.fileSize) / 1024 / 1024 > 10) {
					this.$message.warning('该附件过大，请下载后预览。')
					return
				}
				window.open(this.$previewUrl + previewUrl(url), '_blank')
			} else if (type === 'delete') {
				this.deleteFile(data, true)
			} else {
				window.open(url, '_blank')
			}
		},

		// 全选
		checkBoxChange(status, data) {
			data.list.forEach((x) => {
				this.$set(x, 'active', status)
			})
			this.sumSelectNum()
			this.onlyOneImg(false, data)
		},

		// 单个点击
		clickImg(data, item) {
			let status = data.active ? false : true
			this.$set(data, 'active', status)
			let list = item.list.filter((x) => x.active)
			item.checked = list.length == item.list.length ? true : false
			this.sumSelectNum()
			if (status) {
				// 选中时 给选中图片加一个选中时间
				let nowDate = this.$utils.toDateString(
					new Date(),
					'yyyy-MM-dd HH:mm:ss'
				)
				this.$set(data, 'selectTime', nowDate)
				// // 如果弹窗是打开的，那么不用继续打开
				if (!this.previewObj.show) {
					this.previewObj.show = true
				}
				// // 拼凑展示的图片路径
				this.previewObj.url =
					this.uploadUrl + data.fileDirectory + data.fileName
				// 获取图片详细信息
				this.onlyOneImg(status, data)
			} else {
				// 如果是取消选中，那么先将取消项的选中时间置为null
				this.$set(data, 'selectTime', null)
				// 然后获取selectTime有值的数据
				let list = this.$utils.filterTree(
					this.rightData,
					(item) => {
						if (item.selectTime) {
							return item
						}
					},
					{ children: 'list' }
				)
				// 将获取到的数据降序排列
				let orderList = this.$utils.orderBy(list, [
					['selectTime', 'desc'],
				])
				// 数据大于0是，下标为0 的就是最新被选中的
				// 数据为空直接关闭弹窗
				if (orderList.length > 0) {
					this.previewObj.url =
						this.uploadUrl +
						orderList[0].fileDirectory +
						orderList[0].fileName
					this.onlyOneImg(true, orderList[0])
				} else {
					this.previewClose()
				}
			}
		},

		// 只有一个图片选中时触发
		onlyOneImg(status, data) {
			let list1 = this.$utils.filterTree(
				this.rightData,
				(item) => {
					return item.active
				},
				{ children: 'list' }
			)
			if (status) {
				this.detailObj = {}
				let params = status ? data : list1[0]
				this.getImageInfo(params)
			}
		},

		// 移入时查看性情
		viewInfo(data) {
			this.getImageInfo(data)
		},

		/**
		 * @description: 顶部按钮及搜索区域
		 */
		// 顶部按钮
		async topBtnClick(type) {
			if (type == 'upload') {
				this.uploadObj.show = true
				return
			}
			let list = this.$utils.filterTree(
				this.rightData,
				(item) => {
					return item.active
				},
				{ children: 'list' }
			)
			if (list.length === 0) {
				this.$message.warning('至少勾选一张照片！')
				return
			}
			// 不可删除
			let ass = 'assortment'
			let cre = 'createUserid'
			let userId = this.userInfo.id
			let noDeleteList = list.filter((x) => {
				if (x[ass] != 'picture' || x[cre] != userId) {
					return x
				}
			})
			// 删除
			let deleteList = list.filter((x) => {
				if (x[ass] == 'picture' && x[cre] == userId) {
					return x
				}
			})
			let that = this
			function handleType(type, deleteList) {
				if (type == 'download') {
					list.map((x, index) => {
						that.handleClick(type, x)
					})
					return
				}
				if (type == 'delete') {
					deleteList.map((x, index) => {
						let status =
							index == deleteList.length - 1 ? true : false
						that.deleteFile(x, status)
					})
					if (deleteList.length == 0) {
						that.getImageData()
						that.previewClose()
					}
				}
			}
			if (type == 'delete') {
				const h = this.$createElement
				let pictureName = ''
				if (noDeleteList.length > 0) {
					pictureName = '（\u00A0\u00A0'
					let str = ''
					noDeleteList.forEach((x, index) => {
						str += '图片' + x.fileName + ',\u00A0\u00A0'
					})
					pictureName += str + '\u00A0\u00A0不可删除！）'
				}
				let str = '仅可删除在项目相册处自己上传的图片，是否确定删除？'
				let style = 'color:red;text-align:left;word-break:break-all'
				let endStr = `\u00A0点击确定后将会直接删除可删除的图片！`
				let message = h('div', [
					h('p', null, str),
					h('p', { style }, pictureName),
					h('p', { style: 'text-align: left' }, endStr),
				])
				this.$msgbox({
					title: '提示',
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					center: true,
					message,
				})
					.then(() => {
						handleType(type, deleteList)
					})
					.catch(() => {
						this.$message.info('已取消删除')
					})
				return
			}
			handleType(type)
		},

		// 查询表单
		submitForm() {
			this.getImageData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.searchForm.fileName = ''
			this.getImageData()
		},

		// 取消选中
		cancelClick() {
			this.detailObj = {}
			this.$utils.eachTree(
				this.rightData,
				(item) => {
					if (item.id) {
						item.active = false
					} else {
						item.checked = false
					}
				},
				{ children: 'list' }
			)
			this.activeImageNum = 0
		},

		// 计算选中人数
		sumSelectNum() {
			this.activeImageNum = 0
			this.$utils.eachTree(
				this.rightData,
				(item) => {
					if (item.id) {
						if (item.active) {
							this.activeImageNum += 1
						}
					}
				},
				{ children: 'list' }
			)
		},

		/**
		 * @description: 弹窗先关
		 */

		// 关联任务change
		taskChange(data) {
			this.uploadObj.taskId = data
		},

		// 上传按钮
		uploadClick(type) {
			if (type == 'cancel') {
				this.uploadClose()
				return
			}
			if (this.uploadObj.taskId === '') {
				this.$message.warning('请选择关联任务！')
				return
			}
			this.uploadObj.loading = true
			this.$refs.fileUpload.fileSend(
				this.uploadObj.taskId,
				this.projectId,
				() => {
					// 上传弹窗关闭
					this.uploadClose()
				},
				() => {
					this.uploadObj.show = false
					this.uploadObj.loading = false
				}
			)
		},

		// 上传弹窗关闭
		uploadClose() {
			this.uploadObj.show = false
			this.uploadObj.loading = false
			this.uploadObj.taskId = ''
			this.getImageData()
		},

		// 预览弹窗关闭
		previewClose() {
			this.previewObj.show = false
			this.previewObj.url = ''
		},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		uploadUrl() {
			return this.$uploadUrl
		},
	},
}
</script>

<style lang='less' scoped>
.project-images {
	padding: 20px;
	padding-top: 0;
	height: 100%;
	.header-top {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #eee;
		.btnGroups {
			display: flex;
			align-items: center;
		}
	}
	.container {
		display: flex;
		.left {
			width: 150px;
			height: calc(~'100vh - 360px') !important;
			padding: 0 10px;
			padding-top: 10px;
			overflow-y: auto;
			border-right: 1px solid #eee;
		}
		.right {
			width: calc(~'100% - 450px');
		}
		.details {
			width: 300px;
			min-width: 300px;
			padding: 10px 15px;
			background-color: #f5f6fa;
			font-size: 14px;
			line-height: 32px;
			overflow-y: auto;
			height: calc(~'100vh - 360px');
			.font-bold {
				font-weight: bold;
			}
		}
		.custom-descriptions-images {
			::v-deep .el-descriptions__header {
				margin-bottom: 10px;
			}
			::v-deep .el-descriptions__body {
				background-color: transparent;
			}
		}
		.fz14 {
			font-size: 14px;
		}
		.btn {
			padding: 0 50px;
		}
		.check_color {
			/deep/.el-timeline-item__node {
				background: #3fa3ff !important;
			}
		}
		.active_color {
			color: #3fa3ff;
		}
		.c-p {
			cursor: pointer;
			user-select: none;
		}
		.c-p:hover {
			.active_color();
		}
		.circle {
			position: absolute;
			z-index: 999;
			background-color: #e4e7ed;
			border-radius: 50%;
			width: 12px;
			height: 12px;
			left: -1px;
			top: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			.inner-circle {
				display: inline-block;
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background-color: #fff;
			}
		}
		.blue_bgc {
			background-color: #3fa3ff !important;
		}
		.screen-box {
			padding: 10px 0;
		}
		.content {
			display: flex;
			flex-wrap: wrap;
			.el-image {
				border: 1px solid #eee;
				width: 160px;
				height: 160px;
				.image-slot {
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #c0c4cc;
				}
			}
			.el-image + .el-image {
				margin-left: 20px;
			}
			.hoverBox {
				position: relative;
				.activeImg {
					border: 2px solid #0099ff !important;
				}
				.activeIcon {
					background-color: #0099ff !important;
					position: absolute;
					top: -140px;
					left: 10px;
					z-index: 99;
					border-radius: 50%;
					display: inline-block;
					width: 23px;
					height: 23px;
					line-height: 28px;
					text-align: center;
					i {
						font-size: 16px;
						font-weight: bolder;
						color: #fff !important;
					}
				}
			}
		}
	}

	.no-data {
		margin: 0 auto;
		.el-empty__image {
			width: 300px;
		}
	}
}
.summary-dlg {
	.el-dialog__wrapper {
		pointer-events: none;
		/deep/ .el-dialog {
			pointer-events: auto;
		}
		.el-dialog__body {
			pointer-events: auto;
			max-height: 600px !important;
		}
	}
	.el-dialog__header {
		pointer-events: auto !important;
	}
	.preview-box-projectData {
		height: 540px;
		img {
			width: 100%;
			height: 100%;
		}
	}
}
.resetHeight {
	.el-dialog__wrapper {
		.el-dialog__body {
			max-height: 400px !important;
		}
	}
	.preview-box-projectData {
		height: 340px;
	}
}
</style>